import { FC } from 'react';

import AutocompleteField, { AutocompleteFieldProps } from '@app/components/common/autocomplete-field';

export const RouteNumberField: FC<AutocompleteFieldProps> = ({ value, onChange, ...props }) => { 
  return <AutocompleteField 
    id='route_number_field'  
    value={value}
    onChange={onChange}
    {...props}
  />;
};
